<template>
  <div id="glc-acknowledgement">
    <v-card class="premium-dialog-card overflow-hidden">
      <!-- Premium App Bar -->
      <v-app-bar class="premium-app-bar" dark flat height="80">
        <v-avatar color="rgba(255,255,255,0.2)" size="48" class="mr-4">
          <v-icon>mdi-shield-check</v-icon>
        </v-avatar>
        <v-toolbar-title class="text-h5 font-weight-black">
          {{ pageDescription }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closePrompt" class="mr-2">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card-text class="pa-8 pt-10">
        <v-container class="pa-0">
          <v-row>
            <v-form ref="form2" v-model="valid1" lazy-validation v-on:submit.prevent="submitForm" style="width: 100%">
              <!-- Training Target Info -->
              <v-col cols="12" class="mb-8">
                <v-card class="target-info-card pa-6" flat>
                  <div class="d-flex align-center">
                    <v-icon x-large color="indigo lighten-2" class="mr-6">mdi-office-building-marker</v-icon>
                    <div>
                      <div class="text-overline indigo--text font-weight-bold" style="line-height: 1">Recommendation
                        For
                      </div>
                      <div class="text-h4 font-weight-black grey--text text--darken-3">{{ row.LomName }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>



              <!-- NHQ History Section -->
              <v-col cols="12"
                v-if="(category == 1 && LomTrainingDetails.LdmtDescription) || (category == 2 && LomTrainingDetails.LavDescription)">
                <div class="history-section mb-6">
                  <div class="d-flex align-center mb-3">
                    <v-icon color="green darken-2" class="mr-2">mdi-history-text</v-icon>
                    <span
                      class="text-subtitle-1 font-weight-black green--text text--darken-3 uppercase letter-spacing-1">NHQ
                      Acknowledgment
                      History Log</span>
                  </div>
                  <v-card flat class="history-box pa-6 rounded-xl border-green"
                    v-html="category == 1 ? LomTrainingDetails.LdmtDescription : LomTrainingDetails.LavDescription">
                  </v-card>
                </div>
              </v-col>

              <!-- GLC Previous History -->
              <v-col cols="12" v-if="LomTrainingDetails.GlcDescription">
                <div class="history-section mb-6">
                  <div class="d-flex align-center mb-3">
                    <v-icon color="indigo darken-2" class="mr-2">mdi-comment-quote-outline</v-icon>
                    <span
                      class="text-subtitle-1 font-weight-black indigo--text text--darken-3 uppercase letter-spacing-1">GLC
                      Recommendation Archive</span>
                  </div>
                  <v-card flat class="history-box pa-6 rounded-xl border-indigo"
                    v-html="LomTrainingDetails.GlcDescription">
                  </v-card>
                </div>
              </v-col>
              <!-- Status Summary -->
              <v-col cols="12" class="mb-4">
                <div class="d-flex flex-wrap gap-4">
                  <div v-if="LomTrainingDetails.TrainingStatusTxt"
                    class="d-flex align-center px-4 py-3 rounded-lg grey lighten-4 border flex-grow-1 mr-4">
                    <v-icon small color="indigo" class="mr-3">mdi-information-outline</v-icon>
                    <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2 mr-3">NHQ Current
                      Acknowledgment:</span>
                    <v-chip :color="LomTrainingDetails.TrainingStatusColor" small dark class="font-weight-black px-4">
                      {{ LomTrainingDetails.TrainingStatusTxt }}
                    </v-chip>
                  </div>

                  <div v-if="LomTrainingDetails.GlcStatusTxt"
                    class="d-flex align-center px-4 py-3 rounded-lg grey lighten-4 border flex-grow-1">
                    <v-icon small color="navy" class="mr-3">mdi-shield-check-outline</v-icon>
                    <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2 mr-3">GLC Current
                      Recommendation:</span>
                    <v-chip :color="LomTrainingDetails.GlcStatusColor" small dark class="font-weight-black px-4">
                      {{ LomTrainingDetails.GlcStatusTxt }}
                    </v-chip>
                  </div>
                </div>
              </v-col>
              <!-- Input Section -->
              <v-col cols="12">
                <div class="input-section pa-8 rounded-xl elevation-2 bg-white">
                  <div class="d-flex align-center mb-4">
                    <v-icon color="amber darken-3" class="mr-3">mdi-note-edit</v-icon>
                    <span class="text-h6 font-weight-black grey--text text--darken-3">New Recommendation Remarks</span>
                  </div>

                  <v-textarea outlined v-model="Description" :rules="DescriptionRules" name="input-7-4"
                    label="Provide detailed description or remarks..." class="premium-textarea mb-6" counter rows="4"
                    rounded backgroundColor="grey lighten-5"></v-textarea>

                  <v-divider class="mb-8"></v-divider>

                  <v-row class="px-2">
                    <v-col cols="12" sm="4">
                      <v-btn :disabled="!valid1" @click.prevent="submitForm(1)" :loading="ApproveLoadingFlag"
                        class="premium-action-btn btn-yes w-100" x-large block>
                        <v-icon left>mdi-check-decagram</v-icon> Recommended
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-btn :disabled="!valid1" @click.prevent="submitForm(2)" :loading="RejectLoadingFlag"
                        class="premium-action-btn btn-no w-100" x-large block>
                        <v-icon left>mdi-close-circle</v-icon> Not Recommended
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-btn @click.prevent="closePrompt()" class="premium-action-btn btn-cancel w-100" x-large block>
                        <v-icon left>mdi-close</v-icon> Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-form>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.premium-dialog-card {
  /* Approved Design System */
  --navy: #3A67B1;
  --aqua: #0097D7;
  --gold: #EDBE38;
  --seaform: #56BDA3;
  --text-90: #414042;
  --text-off-black: #0A0F29;
  --white: #FFFFFF;

  border-radius: 32px !important;
  background: #f8f9fa !important;
  font-size: 1.1rem !important;
}

.premium-app-bar {
  background: linear-gradient(135deg, var(--navy) 0%, var(--aqua) 100%) !important;
}

.target-info-card {
  background: white !important;
  border-radius: 24px !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03) !important;
  color: var(--text-off-black) !important;
}

.history-box {
  background: white !important;
  line-height: 1.6;
  font-size: 1.1rem !important;
  color: var(--text-90) !important;
}

.border-green {
  border-left: 6px solid var(--seaform) !important;
  background: #f1f8e9 !important;
}

.border-indigo {
  border-left: 6px solid var(--navy) !important;
  background: #e8eaf6 !important;
}

.input-section {
  border: 1px solid #eceff1;
}

.premium-textarea>>>fieldset {
  border-color: #cfd8dc !important;
}

.premium-textarea.v-input--is-focused>>>fieldset {
  border-color: var(--navy) !important;
  border-width: 2px !important;
}

.premium-action-btn {
  text-transform: none !important;
  font-weight: 800 !important;
  letter-spacing: 0.8px !important;
  border-radius: 16px !important;
  color: white !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-size: 1.1rem !important;
}

.btn-yes {
  background: linear-gradient(135deg, var(--seaform) 0%, #2e7d32 100%) !important;
  box-shadow: 0 6px 20px rgba(46, 125, 50, 0.3) !important;
}

.btn-yes:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(46, 125, 50, 0.4) !important;
}

.btn-no {
  background: linear-gradient(135deg, #f57c00 0%, #e65100 100%) !important;
  box-shadow: 0 6px 20px rgba(230, 81, 0, 0.3) !important;
}

.btn-no:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(230, 81, 0, 0.4) !important;
}

.btn-cancel {
  background: linear-gradient(135deg, #757575 0%, #424242 100%) !important;
  box-shadow: 0 6px 20px rgba(66, 66, 66, 0.3) !important;
}

.btn-cancel:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(66, 66, 66, 0.4) !important;
}

.text-h4 {
  font-size: 2.125rem !important;
  line-height: 2.5rem !important;
  font-weight: 900 !important;
}

.text-h5 {
  font-size: 1.8rem !important;
  font-weight: 800 !important;
}

.text-h6 {
  font-size: 1.4rem !important;
  font-weight: 800 !important;
}
</style>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    row: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
    category: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      Description: "",
      DescriptionRules: [(v) => !!v || "Description is required"],
      valid1: true,
      StatusFlag: false,
      ApproveLoadingFlag: false,
      RejectLoadingFlag: false,
      LomTrainingDetails: {},
    };
  },
  mounted() {
    console.log("mounted called");
    this.getRecordDetails();
  },
  methods: {
    getRecordDetails() {
      console.log("getRecordDetails called");
      var tr = this.row;
      var id = this.category == 1 ? tr.LomTrainingId : tr.LomTrainingLavId;
      console.log({ id });
      var lom_id = tr.LomId;

      if (id > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        var show_url = server_url + "api/lom-training/show";
        var upload = {
          LoTraining: id,
          Category: this.category,
          Lo: lom_id,
        };

        const thisIns = this;

        this.$http({
          url: show_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            var flag = response.data.flag;
            var records = response.data.records;

            if (flag == 1) {
              thisIns.LomTrainingDetails = records;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", this.StatusFlag);
    },
    submitForm(Status) {
      console.log("submitForm is called");
      console.log({ Status });

      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var tr = this.row;
      var id = this.category == 1 ? tr.LomTrainingId : tr.LomTrainingLavId;
      console.log({ id });

      if (validate1 && Status > 0 && id > 0) {
        switch (Status) {
          case 1:
            this.ApproveLoadingFlag = true;
            break;
          case 2:
            this.RejectLoadingFlag = true;
            break;
        }

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        var add_url = server_url + "api/lom-training/glc-approval-update";
        var upload = {
          UserInterface: Status,
          LomTraining: id,
          Description: this.Description,
          Category: this.category,
        };

        const thisIns = this;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            thisIns.ApproveLoadingFlag = false;
            thisIns.RejectLoadingFlag = false;

            var flag = response.data.flag;
            var output = response.data.output;

            if (flag == 1) {
              thisIns.StatusFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            thisIns.ApproveLoadingFlag = false;
            thisIns.RejectLoadingFlag = false;
            thisIns.sweetAlert("error", "Failed to update Recommendation", false);
          });
      }
      else {
        if (!validate1) {
          this.sweetAlert("error", "Please validate the form", false);
        } else if (Status <= 0) {
          this.sweetAlert("error", "Please select a status", false);
        } else if (id <= 0) {
          this.sweetAlert("error", "Lo Training Details not Found.", false);
        }
      }
    },
  },
};
</script>
